import ActivitySelectorDomFactory from '../factory/activity-selector-factory';
import Builder from '../../common/builder/builder';

type Elements = {
  wrapper: HTMLElement;
  selectButton?: HTMLButtonElement;
  createButton?: HTMLButtonElement;
};

export default class ActivitySelectorBuilder extends Builder<
  Elements,
  ActivitySelectorDomFactory
> {
  public withCreateButton(onClick: () => void) {
    this.elements.createButton = this.factory.createButton({
      text: this.factory.i18n.t('Create activity'),
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"></path></svg>',
    });
    this.elements.createButton?.addEventListener('click', onClick);
    this.elements.wrapper?.appendChild(this.elements.createButton);
    return this;
  }
  public withSelectButton(onClick: () => void) {
    this.elements.selectButton = this.factory.createButton({
      text: this.factory.i18n.t('Select activity'),
      svg: `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
  <path stroke-linecap="round" stroke-linejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
</svg>
      `,
    });
    this.elements.selectButton?.addEventListener('click', onClick);
    this.elements.wrapper?.appendChild(this.elements.selectButton);
    return this;
  }
}
